import { MyPlan } from "../../Billing/MyPlan";

// the Dashboard's "Plan" panel shows the doctor's real plan (it used to show fixed sample values)
export const Plan = () => <MyPlan embedded />
